import React, { useState } from "react";
import Enquiries from "./Enquiries";
import MedicineOrder from "./MedicineOrder";
import ProfileSideBox from "./ProfileSideBox";
import axios from "axios";
import PersonalInformation from "./PersonalInfomation";

const ProfileSideBar = () => {
  const [activeTab, setActiveTab] = useState("Personal Information");
  const [searchPatientId, setSearchPatientId] = useState("");
  const [patientData, setPatientData] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const handleSearch = async () => {
    if (!searchPatientId.trim()) return;

    try {
      setLoading(true);
      const res = await axios.get(`${apiUrl}search/patient-details`, {
        params: { patientId: searchPatientId },
      });
      setPatientData(res.data || null);
    } catch (error) {
      console.error("Patient fetch failed", error);
      setPatientData(null);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Personal Information":
        return <PersonalInformation data={patientData} loading={loading} />;
      // case "Enquiries":
      //   return <Enquiries />;
      // case "Medicine Order":
      //   return <MedicineOrder />;
      default:
        return <PersonalInformation data={patientData} loading={loading} />;
    }
  };

  return (
    <div className="flex flex-col gap-4 cb-fade-in">
      {!patientData ? (
        // Centered search UI
        <div className="flex items-center justify-center min-h-[62vh]">
          <div className="flex flex-col items-center gap-5 bg-panel border border-hairline rounded-cb-md shadow-cb-sm px-5 sm:px-10 py-12 max-w-md w-full">
            <div className="text-center">
              <div className="cb-eyebrow mb-1.5">Patients</div>
              <h2 className="text-t-2xl font-semibold text-fg-strong">
                Look up a patient
              </h2>
              <p className="text-t-sm text-fg-muted mt-1">
                Enter a patient ID to view their profile and history.
              </p>
            </div>
            <div className="flex gap-2 w-full">
              <input
                type="text"
                className="flex-1 h-9 px-3 border border-hairline rounded-cb-sm bg-panel text-t-md outline-none focus:border-ink-500 focus:shadow-cb-focus transition-shadow"
                placeholder="Patient ID"
                value={searchPatientId}
                onChange={(e) => setSearchPatientId(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
              <button
                onClick={handleSearch}
                className="h-9 px-5 bg-ink-600 hover:bg-ink-700 text-fg-on-ink text-t-md font-medium rounded-cb-sm transition-colors"
              >
                {loading ? "Loading…" : "Search"}
              </button>
            </div>
          </div>
        </div>
      ) : (
        // Profile layout after search
        <>
          <div className="flex flex-wrap justify-between items-center gap-4 bg-panel border border-hairline rounded-cb-md p-3">
            <span className="cb-eyebrow">Patient profile</span>
            <div className="flex flex-wrap items-center gap-2">
              <input
                type="text"
                className="h-8 px-2.5 border border-hairline rounded-cb-sm bg-panel text-t-md outline-none focus:border-ink-500 focus:shadow-cb-focus transition-shadow"
                placeholder="Patient ID"
                value={searchPatientId}
                onChange={(e) => setSearchPatientId(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              />
              <button
                onClick={handleSearch}
                className="h-8 px-5 bg-ink-600 hover:bg-ink-700 text-fg-on-ink text-t-md font-medium rounded-cb-sm transition-colors"
              >
                {loading ? "Loading…" : "Search"}
              </button>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-4 bg-panel border border-hairline rounded-cb-md p-4">
            <ProfileSideBox
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              patientDetails={patientData?.successObject?.patientDetails}
            />

            <div className="w-full lg:w-[82%] flex flex-col gap-4">{renderContent()}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfileSideBar;
